import { appConfig } from '../app.config';
import { Service } from '../models/service.model';

const baseUrl = appConfig().assets_host + "/img";

const services: { [key in Service | 'selection']: any } = {
	selection: {
		name: 'выбор направлений'
	},
	implantation: {
		name: 'имплантация',
		accusative: 'имплантацию',
		preview: baseUrl + "/preview_implantation.jpg"
	},
	prosthetics: {
		name: 'протезирование',
		accusative: 'протезирование',
		preview: baseUrl + "/preview_prosthetics.jpg"
	},
	braces: {
		name: 'брекеты/элайнеры',
		accusative: 'установку брекетов/элайнеров',
		preview: baseUrl + "/preview_braces.jpg"
	},
	remove: {
		name: 'удаление зубов',
		accusative: 'удаление зубов',
		preview: baseUrl + "/preview_remove.jpg"
	},
	treatment: {
		name: 'лечение зубов',
		accusative: 'лечение зубов',
		preview: baseUrl + "/preview_treatment.jpg"
	},
	whitening: {
		name: 'отбеливание',
		accusative: 'отбеливание зубов',
		preview: baseUrl + "/preview_whitening.jpg"
	},
	veneers: {
		name: 'виниры и реставрация',
		accusative: 'виниры и реставрацию',
		preview: baseUrl + "/preview_veneers.jpg"
	},
	pediatrics: {
		name: 'дет. стоматология',
		accusative: 'детскую стоматологию',
		preview: baseUrl + "/preview_pediatrics.jpg"
	},
	gums: {
		name: 'лечение десен',
		accusative: 'лечение десен',
		preview: baseUrl + "/preview_gums.jpg"
	},
	crowns: {
		name: 'установка коронок',
		accusative: 'установку коронок',
		preview: baseUrl + "/preview_crowns.jpg"
	},
	cleaning: {
		name: 'чистка зубов',
		accusative: 'чистку зубов',
		preview: baseUrl + "/preview_cleaning.jpg"
	},
	rem_wisdom: {
		name: 'удаление зубов мудрости',
		accusative: 'удаление зубов мудрости',
		preview: baseUrl + "/preview_remove_wisdom.jpg"
	},
	only_braces: {
		name: 'ортодонтия/брекеты',
		accusative: 'установку брекетов',
		preview: baseUrl + "/preview_braces.jpg"
	},
	only_eliners: {
		name: 'элайнеры',
		accusative: 'установку элайнеров',
		preview: baseUrl + "/preview_braces.jpg"
	},
	bite: {
		name: 'исправление прикуса',
		accusative: 'исправление прикуса',
		preview: baseUrl + "/preview_braces.jpg"
	},
	no_palate_prosthetics: {
		name: 'протезирование без нёба',
		accusative: 'протезирование без нёба',
		preview: baseUrl + "/preview_prosthetics.jpg"
	},
	cheap_prosthetics: {
		name: 'дешёвое протезирование',
		accusative: 'дешёвое протезирование',
		preview: baseUrl + "/preview_prosthetics.jpg"
	},
	ped_orthodontics: {
		name: 'дет. ортодонтия',
		accusative: 'детскую ортодонтию',
		preview: baseUrl + "/preview_braces.jpg"
	},
	ped_orthodontics_var2: {
		name: 'дет. ортодонтия',
		accusative: 'детскую ортодонтию',
		preview: baseUrl + "/preview_braces.jpg"
	},
	ped_orthodontics_var3: {
		name: 'дет. ортодонтия',
		accusative: 'детскую ортодонтию',
		preview: baseUrl + "/preview_braces.jpg"
	},
	ped_orthodontics_var4: {
		name: 'дет. ортодонтия',
		accusative: 'детскую ортодонтию',
		preview: baseUrl + "/preview_braces.jpg"
	},
	pediatrics_var2: {
		name: 'дет. стоматология',
		accusative: 'детскую стоматологию',
		preview: baseUrl + "/preview_pediatrics.jpg"
	},

}

export default services;